export default [
    {
        "id": 1,
        "nickname": "小美·716",
        "userId": "1954365742",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTNfMTk1NDM2NTc0Ml8xX2hkMTg4Xzc3OQ==_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000277756247; userId=1954365742; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAH3hYBsGO_VDBIIEwqrikMIxUdWp7pvz8EtB7oNQRAPd-JbBV-pvfpns6ZrhyPG25n2F9jLE3Lst5epB-yfH0Scwp-plZ1vDVY1JJvITEQ72OSUf4PvxPMyX4zf6qzucdYxsxCGEvHDgDTB8lgJntfOA9U-ssZpHVo-4Jo9XjtooYnMpE8XlWtVrWHMV0vh-zVITHsEwUaFA3rKSVOJdbJmGhLSubyi-uEBAthqCoUoWxNxjR0iIC__Mjt7jY7DAU3zOZRCbD5OC3fkcvYI5lKjmK92dfX5KAUwAQ; kuaishou.shop.b_ph=f5da0cd2a9a4c4ba86172351db0007d3e3f6; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAe7ifVgFfDQ0A8XYFalawVdPKnFhqorKFT9k76_exuccmHddIVzi_PbOPGWt8WnkEQQPqZB3u-Kv_n4iNNZhMBtcCu08ovYUmmM4DxLLVGjzfZ0zyrk2Kq2thzyGPd_HCkucIrrARGGnO9GwICTcwAcQD8EZ15i211a2y02gOh_2mrk8NnL7reC4DoHd5-SC1VjcUoYGT__Ui1263cafSmkPnCmKtMou0fPeBEvjhCtuGhLBQhRfbrn6PLR9rKF_P-8CoiUiIOTDiZcwsTO2eEEVAzG9VEFg0KbGm0KFSSWyS0jp_605KAUwAQ; kuaishou.ad.analysis_ph=04297b87dad861d05197c40826c3231bf773\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 2,
        "nickname": "娇妹·716",
        "userId": "2131929203",
        "type": 1,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/01/BMjAyNTExMjUwMTEwNDVfMjEzMTkyOTIwM18xX2hkOTNfMzAw_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000015505141; userId=2131929203; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHYghUY8nFkgu_6VTJ-OluNyXFYbaIXQ_kNlUPz6vRXOiCLhis2JFMQtliRLljuccnVrLuQl9Lk0C2Yt45cDpKENH-Z9Vud2BEXECQpue9p6wcqZFOTAe3O8hjlwLeJtrJlOAzZZ54PsPpsXs9wLAHYJvTYFc82yVbpVfQJThT-qsYeV2UV5fkbAKckCm9uGo5jJYi30SDkjw4AWONsrI_HGhL2Uaiw4Gra-mmbJWHEsndFLBsiIM8OsQA-TqYKXveIxvUr6Q_ZzTdrvHUJBriR0S8-r-W4KAUwAQ; kuaishou.shop.b_ph=474937e6c3102d5d2bd85b4d7f0d471f75ec; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAYngjVql8w_eeZh1mw6i9AULWSHM9U72x49I2gD9DODGOcBh_bZEQ7vKuXftZMShn_Wak6xg7mplvtow3MzJdtvHLZRTj58vOj1mTH-uyVNVlEtTV6y-5Ie5qoL_9DuAXm8Za2a-D2GiZOc7MM4bHSeddbU9XBt9nqS8jUsJvjnl4fz7OPaFXJn1y9NMCVnwnPfpSk9dOy_ke4_2cM1i4QZKXKw6UZP8P60CDJVQg30kGhKTBHJQbcZcM12A-cqhA_VUDQMiIOIU6uhxYZm4BqY5vm-vJzjna-BSNeYSrxeDN045dludKAUwAQ; kuaishou.ad.analysis_ph=93d46d5773f4d83b588dbdefcd0a43863e22\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 3,
        "nickname": "嘉文·716",
        "userId": "371800776",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/07/BMjAyNTEwMDQwNzQ1MTFfMzcxODAwNzc2XzFfaGQ3NV81NjI=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 4,
        "nickname": "志虎·716",
        "userId": "8427947",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjA4MjZfODQyNzk0N18xX2hkNTY4XzQ3_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000010986245; userId=8427947; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFJAOrj6KkRrWpK1gIUN21-5qj6KBlBor-agxoGSkPJ1a_Ev8TcEL6mGS8eDlLJU3PMePpSUEThmf4sB6nNtbvqHtCzasmVk5G6GHBjWEu049L9KeG9UX7ABoFglBNce6Q5nNcpYFfV4R7158pUrUkAxwiDSUjebWPoh9cjJjS4tx5GAyjYtihUdlwORdJOVRtC3FZEqrh7XuT4Ys9GQN7AGhLo_Z2VG4WxceKArz4eXu24hPEiIA-Rt2f0pIPin21lkMQZJlhdyAmA4kdj1-cQ03UmFSiZKAUwAQ; kuaishou.shop.b_ph=19d18cb6fc136b8cbdb5dd09ecb24d18fa6c; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAYPN1km0eVPi6siAZ_3WN61WTwKS35Zx27WzFdcpCysAHH5--aAksZ8cW26eiMGHoyHxhO1QqyuiTWVVNeS6DTey7Fm96oCgC1vsRsjjRT6EDyAEZYIYLwViWwC4dVkmbOLhi9sn3pi-T9gv-7gZEHpjQ1zSjYzkp1dNgCWiT3CDP922Qa0CSaM_f4JEcKF57T3jgXipyR2DrGr5yRMkNUUdQoFNBMUxlQ_koUmnPNN5GhJTq2ODdjhJ6SRw9AjqUvtEh54iIGtj9HdVb6XtIY1BxmLwTfB3uGbt6D6K_ZiPXRljk9ZKKAUwAQ; kuaishou.ad.analysis_ph=9d9f67c577ce0c6752aa4f5c45945c3503ae\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 5,
        "nickname": "天启·716",
        "userId": "331833119",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODM1MTVfMzMxODMzMTE5XzFfaGQxNzFfNDMy_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 6,
        "nickname": "懵圈·716",
        "userId": "16194648",
        "type": 1,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2024/07/10/21/BMjAyNDA3MTAyMTIzMDBfMTYxOTQ2NDhfMV9oZDk4NV8xNzI=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000002415749; userId=16194648; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAG_E08Hu2d2xucqFdQlxcwbJbSKn_V_VTkfn6tQ7thV-3zhwB2Dimzd-ICQ3Gmzmf4MLDYXMY0qkl_nWcc_K4XOABGtkWInWU3T_X_f53hBa1jPZo_cc-4oI9NR9XtZbbUekC_MgoE8rnhRqvEnyJ2xanMFtjjLvFjMKThOvoFtRa-z8EXHJxU1_doj3Ui7fuKFiWeExY_-6K8tMHnYm79qGhLJEp5dRe8bRzILp4WlbdDTnPsiIL96QMxuHPkoLyIGmUbDGmvWRHvO60sw3BPIQEzkemY6KAUwAQ; kuaishou.shop.b_ph=8a57760e21b41361562904c62b33685b49c5; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAZnTrVCKxDhl5RNIqxfDyj8mw-fG1iA6n0xyQ0z11tyY2nRPbYII1zsENJiIdtzf5byp91TFPMnD9wQz9UqLEI-QpVSxHSuvTCo6Z-E1Npcs7thNHUnLVHeKowHhmls_QJJMSZfu6-Q_i-1EEGxwm8Mbdmt1IfpiT-98lcHVE2nIgkwJKYFTST9V9WUTEDmhZT06cI-ozgOdCnMH-6Xn69arUutxJ0l4VdmoX43m-s9SGhLp8hicmEEI9gcCpeePxY__tVYiICADXQ-syK-x2lyeCIzy2T2E54PqrWMdIWcRUQenXhCfKAUwAQ; kuaishou.ad.analysis_ph=681f5e8189d21ef482385dbe9f4487a15de3\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 7,
        "nickname": "雅儿·716",
        "userId": "73911771",
        "type": 1,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTU5NTRfNzM5MTE3NzFfMV9oZDYxOF83NTU=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011566265; userId=73911771; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAElOT-ayakMkhszqBEULyMjjTiGfHe6vT6w2l2mGr0rBJMCrGbFc0ReVVcqt9cSUr66xOfjECKXLuDTfZf8uRnltRaWSRi1nlEXoDOcUBpaWpgMAsY8YCf5JKBMe6IO9LJARQ93Z4K1NnybLcoY1FEk4xy5aQzYWco9twj5FyLvNg-aslEAkBCoyUCCd3XeTV7ZR8SXJ1L3AspK8_e9JlRvGhI2yYASXgUPN_H6NBCr-rCyOd4iIL_9Rikptd-E1xAaeLXQo-HF3oF7cqndUpC-iFNh79i6KAUwAQ; kuaishou.shop.b_ph=5be174786e118410e7eb8efb4d5b71525ce0; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAcUkkSrSXFOJMJ5fB9rCP5XE_eXYMBzewLH-_NVoQQvvbfsZHIuor0_eUumodT0S88E0U9dWyntNWAXQrseGY29h3xjMg-Ehu1iXKtwVlG0wolmv3EP-pjr641kyA7pt5vn964Sf1x6yvOOjZQjsxT_AfpVah0SpmarufsWnTvSs7_OlqleNWZdFhOm7YYoxOm-Ud4Dpuug2n6C-qvBmxVvIvXWZxMBs7Iu89TWv1dOOGhLbwz68ZkiTB3sY69L_Qrle9OgiINOKQP0aLxBaZPOQWjcrxgYHKeeQObfRlQrKc9FHuum9KAUwAQ; kuaishou.ad.analysis_ph=ef5bc319300b68579aa9a700989971fe8590\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 8,
        "nickname": "陈小·716",
        "userId": "29982331",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/07/16/00/BMjAyNDA3MTYwMDQ5MzdfMjk5ODIzMzFfMV9oZDg4OF8zOTc=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 9,
        "nickname": "雪儿·716",
        "userId": "11569700",
        "type": 1,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/14/BMjAyNTEwMDQxNDA2NTdfMTE1Njk3MDBfMV9oZDM0Xzg1NA==_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011505740; userId=11569700; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAF_f51xvfwngcR0Hbp5kG2lf635C43ygHb8_eIXTGpY7BOS0oU4awz-TbOJINrPJbinv7dU1xTrza_UeALubw_7P8WIBQVSm3XoA_rxX5W94pDtuIKN0RQQJewlu-uslZq71zJI_Hm9pR47JpjytuUFskpvaQxDstWsbNGzu-Q4jesUzBHbZIZ-dgXh5JXy6NGot-wVKoqaTsRBwrTgI6-IGhJ4oTBo9TU9zBxgYX3KzGIfP4YiIJEYpHcDe0FwRZB0xxx0PNauC5s4zWqON8eH4gOweRrRKAUwAQ; kuaishou.shop.b_ph=253364f6a9fb83a94db6dc11b87c358ffa43; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAZn5-VRP2_K9H1sUytg1B2uocCCziwuLyPB-mtEZjiTUqR5LUEJ7TGEkLr7Qjj74kRSJQUequEUYtZddWqQ2B4LVp0CBftB-z2b1yALJJae6Fuo61EessTLmScdDQEZxVXboZdUpTj8RlRiIrOppQgnLvrOox1ks31QcHsDr8fsmxklhEfZsXQO2f3QEgfxI0rOdAbDIOrhT5Fe1vZtVWwRslTrA0uF8KglkksbdfSJvGhIf-3QptSjo79alO4ig5LPGk-QiIBeObqNbIZYkC3LLb91LRAF9LT4Kd7Y3URkgrMVv9i5zKAUwAQ; kuaishou.ad.analysis_ph=ecbcc70feb9941fead7f76ad87ee0cb8d3fd\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 10,
        "nickname": "依玥·716",
        "userId": "228816049",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjE4MDNfMjI4ODE2MDQ5XzJfaGQ1NTBfNjYy_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000012466271; userId=228816049; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHurqEiMONeMz4otO5wDrbCz-AA6yc89IZBrrULmtpvs9z2PzGLdX5xJyDwgjAGQlT-r6P3pD4WrLtCEazL0zWM8LDJyKMgp8SD6n4GClX5vZ-ZOCzUOLG1EOxT16Yema3kj8sLA554TsiMDhnFmBbwuuF8DNjZmJmTTcA8PiOhPDt-GInoxHORMFWz0U2u0kzcLhhlSKG1eS9BSaeJhr49GhKmF-W_lNyJTm2KnbtfN4jmymsiINMI3yxdRdQ8Sze9R5nvIRQ6XePEKuJCq7H8ugrZPXbKKAUwAQ; kuaishou.shop.b_ph=770124b210473a3fdf572ab3a5e086f40bbb; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAd32_TsaVH00CFxSqcm72xEdF7QfVwhCor7_6GS-uAYEO5xrVlWKFu-PS9Q6S18T29mV6AntHp_QnC8BRBsCycd-OjMIQB-aW_MNKhEuxotGoE9QVOCYMXbWBhF7ByZrScv1mvB5CwXhKlOCGPEzQ81aRdLEUM9j5eoFGLSwesXfyXCssg_BzupMMPKDWxqievct72yrp5A9vEe3HbdW1KhRVG_cbM7eHhDBOi4dAJziGhKfnYlfKFPaF-z---LLO1WfrxQiIPZxMBPtfEBizVLzdlNBcZERRqc_hhnWeIqp7LwO22iuKAUwAQ; kuaishou.ad.analysis_ph=4fe954d5a9cbd3b37dca2d280b7226275050\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 11,
        "nickname": "红妹·716",
        "userId": "511012459",
        "type": 1,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjA0MzRfNTExMDEyNDU5XzJfaGQyODBfNjE2_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011283039; userId=511012459; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAG0HlOuI2_IsIS5s5FxlQDJ72p5oi-wPxzCqDJttaAv9nvt9jpQ-0ZTrnSyEw3C1R-UM6wmLbbPUEqn7twD3LLUDbLzxpmMf94NNU6hwffhr0BarkBXhIja1Oo1nsf-wN7cxjK3DEDQKNsXUVuYeIv2toXQkGDsy7vdY5wvD7qYLYGs0Z4vTwE8JuoQks6a3eJHDGvOGze7B_ygDRJX-QXyGhJxLmZe4hrNJlIURRIhhs2U8_MiIIIoHl_t81tg1vK5Y6Wd9AMtpFwoDtVNjoJNDBDZsBFfKAUwAQ; kuaishou.shop.b_ph=0e757fecc7cb54f5efce8eb713a5b3cbb4ba; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWB6dDVW7V-h85wEm_mdF1IEIfCaks4eGvF0wqK3BffkMK6MeVP9OqZC99tI6ZKmczrdnXspX55KqkBtnBAF0mWmitzwSuFo7jRpcYc2uZrJgUOiO2Ook_n5jabubQ08qf6xWw1ulvOQQIuqjdLXqWMeJn8DmLoQ8J8FI2uz90Ig1e7Vk_4fgXHVwi_xyB6rqve7CHLiZNaP5UFvI7Q_da44IPONvZybTuDDKRJYvolbGhIf-3QptSjo79alO4ig5LPGk-QiIPV5IiYMxdqqU12mTIUzujsaZwBdwRhBvTIatXTkg3FCKAUwAQ; kuaishou.ad.analysis_ph=aa162f908b0aa33b4ca0fb1c250a0183c734\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 12,
        "nickname": "菲宝·716",
        "userId": "50913379",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAwMjhfNTA5MTMzNzlfMV9oZDg2M18xNTA=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000006868736; userId=50913379; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEtKt__R0n6rlKKeURYjQ5y5fx5qTPZDPh67Fm_Lz2Llzz7V-iDmSjOkI1v9VZUla9eLsmWypZF4FDDOLElgYaU7bZOBMHzd9JTrlVum5Dysv7-KbPWYA0mKJBwkLHS3yQ3LqMU2SzCggxg1_nWFLqNMMhnAFISF4CqDfHXKrlZs1n6_vbC-RZlaKXlRT6BdXEDxHqwzg2CdaYHKpB5BT0yGhJxLmZe4hrNJlIURRIhhs2U8_MiIHqsXJ9I_1eCHHvKtHVeEgt2ux5Lv70xQm1hiMvFP9nMKAUwAQ; kuaishou.shop.b_ph=f1b568fd52c2aec12f339b210639943107a2; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAclakkAyIqFbOzTTZwUdoraWnmCnOu5rCFJjapwy1pUn0lSgL8DdtDhYeiPU616A1mcZVcjAEOAPlcUPoN53UfaTkWLRwM4BnIXPA8EnExDO3dcvGEGas92ZOJnKYZdR1MPuorqEHRiBawawyKCusYkeY5U9cWp2eeKVHtihh-i3Npl2ta4ObteEzGmJtu1tEvVCNkzFLbNcDDFT5gKvHoCOANmh3advgvipB_Zmof0zGhLJQvUwrfHcDOIi8qefbDJk8MYiIA1ZJAVLqixEpPwo7c2Q6moeFapCu9gGjeXteF3wqXzvKAUwAQ; kuaishou.ad.analysis_ph=9fe08d8d6b9f4f517dc4fb351fd84149cda2\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 13,
        "nickname": "温柔曦·716",
        "userId": "1256295378",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTAwMjFfMTI1NjI5NTM3OF8xX2hkNTc2XzY2NQ==_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000014891048; userId=1256295378; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFjL82CiqsqnBDAuwb9bhbFs2kxQwxQJzU7iGDoNqr1QTtGGeTHJ-UZWWnpI-cI4PF-37JOhbk9aPSo0-BocDnT4L4aUmMMVH_aG7oJIACnsDRt_SN4O3g60kut149CuPMvDCVGt_l2_R09JMtqr_xJEctls12GrxaBl51rJ26pwC77zMO5XxnPdwx9QNU58-p6enrbT8oTMDfsq1vTKBm6GhLzLRQKxP4poK4hR09Wrd9HhuIiINMIS2wex4jn2qdrVqF_fO_y0wpBn-ArB8IJdY2sNhbLKAUwAQ; kuaishou.shop.b_ph=72ca6b77bff8ee0e70f22d5d67a71a54b1e1; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAa71twSwH_RKat4uEotiHlkEglF0tNE0r5yhg2umo8GUYtrma7FzrwxyqIiwxxolMNh9Mm67X8yJGlp4MywDDKVnjpbXyoEg3dr8Cd6PQ3pfrWINsj1Un9RCsnw27bYYN2okhbX4BptyJOGpDRcZqXbgWPBNB2h2qeTygcC1d7N1Z8EGCoG2fQyvqdfEQRdAbp1XyTk3YMdcfzQC-oLR0zD1aPJVIqI9yRDj0gtJZZwgGhKi1FaAfnwIV9YBgY4y89SVJA8iII-BDvvnDE0VXFwdMW_xgU47SjMnWl58fYi-TL3Ax5QoKAUwAQ; kuaishou.ad.analysis_ph=e188a78e3c6bdbaac4c1504af34a94ff698e\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 14,
        "nickname": "冰冰·716",
        "userId": "47532992",
        "type": 3,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/07/23/BMjAyNTEwMDcyMzQ1MThfNDc1MzI5OTJfMV9oZDE0MV8yNjY=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000015113075; userId=47532992; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHghTo6zPCdKRK3g_da70JeOewr-4OPsRyojW-3fRpZvRQxiRv2Te_LJvXHisyN2FzHZ9m9zwXTB45T_RPTEFtlQRKIDy-Cmf57J-BCdn3vznjQP20_yCOpLlK0oCttuR1N4z1VEIRBi6MzE7O-kcl3uQxPfJ9Bwo4CZf6Eneegj3CLXY3BLKL3qYR_kLVMKLxrW1wubls4norNPxAC7UvFGhIdwFBlxRpZgyh6i0Do-DSRsroiIHkuJGJLdpQj92gB_BJDJN8mGX1yJwMgIVDeUhJV1N0xKAUwAQ; kuaishou.shop.b_ph=94b0cc8815441e88681aefd57ad86d41e726; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAVjPdckiNqO5KGu6VRr53j5XMlNgg2LiKm8kuZtlt_LwgJKNUD7z1PmyMyPrzbqf2_879EQ13TanPoGYQIsJGQVowPUIq-jXpEiZ7ufIVq-m26wZWZqbNAz6hjD-xXc7P5eglY3hZJw4DoMTJbp3YBfdRkJGIhEfFUTZpLDqnG8eGauO4e78kwPWVjtAbAkDWVsl-cVXtDgKNnwQjbas0D0jSxaXcDnCz5_04AJdEWOTGhLp8hicmEEI9gcCpeePxY__tVYiIPrLlYlIcnEDmyBaxqDwQd8M1jjYo7JKBkKgi_xEJFQKKAUwAQ; kuaishou.ad.analysis_ph=60bda9717889bfdf0e4b8ed4637f912a227f\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 15,
        "nickname": "娜娜·雅儿",
        "userId": "2454678977",
        "type": 3,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTEzNTlfMjQ1NDY3ODk3N18xX2hkMTIxXzU5_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000012465986; userId=2454678977; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE_aeu1I9mhwHRlgxpMQ1Wf_8ain7dGcn3cL9BLU2-8tzOu6HC1tNZ51HFQlWiAlzWJoMs3sAM62A5gKLV6E2TWlj8DhcBRDrSQoF_VK09ISdWSKOSttTnixID7ItPNxeT4MfIyy71lVnB6OGK9gvmpTgjGooUruogxHiqAEEDMcbMkPXZolNYYkNHWDplqZrsUhDnQpJLf_TrtxTGSvfFRGhJbNLK1AM9bncnjnr5P1Ut3hAIiIBU7kjvmU_8CbanV6aA3D5ZHxH8Dor47AyhOyxyD2MH0KAUwAQ; kuaishou.shop.b_ph=3760e3ac3359c4644cdb3c0c5db52712d8ef; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAS5Z59VjyP5S7vn9DiPr23xR6UCBJDwyaupiZDO1e-Yf49LVrTFtEa2X_Gf5Sz_68EVJrE6J9ceV5acjeuLj-6wCttnk4cBJySjYq_XLGohIEb7cZ6dJzKh8JjGU-ArzkjKWxq0QqTLw8_x56MuOL-iojkBMhC5sbprqyQeWQr-FWdYHIx_Y26JqzxKEc9LTGBcD5F8Xvsa7T0yZe2qINUO4rUXDFyeRqNGzXUnAa1kHGhJwYppBumOLKmiu-FPdODaje-IiIJ6HSXTk7Z9If_hAAfAf06e5CS44caxWA9ChtAxY6GLjKAUwAQ; kuaishou.ad.analysis_ph=97464a125e4c296ac16cde63051af3b96a9a\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 16,
        "nickname": "萌宝·716",
        "userId": "5913072",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/07/04/BMjAyNTEwMDcwNDM2MTNfNTkxMzA3Ml8xX2hkNTgxXzcxNA==_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000003531885; userId=5913072; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEElhXvVOx8MGc6-KcAmQPV3-QRwnlpPWlDfkn4Qqp5ox9225nhGj7vnEWRwDpTIfuDnNt9P9hjwZ8seBmAopZvDMz9iCqHRsk2wQpoIyLhYtF6NCbO1Fmilp5oKUP-A0P3ufIG_eQallKK6bdk-ciiF1xcSzpx3UkqWkv1J1JZXnfNXDxnt6WL_jOP6qrvnK7VHn8ZhyB1EgL6wC4QKxGBGhKWjgR0Z5KY20AASC-Mzxd_Ru4iIPBShevEQZzvW71YmMUIto00dApc-Ru9dr60C5xwzas_KAUwAQ; kuaishou.shop.b_ph=e8a8e769f4bb2202941eeb00995ab4a26241; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAeWtxcKVMfjYl0YkHiFNflom4A7UYVhcFh1_C-LDDwYqYnhuYK_NYc-GyEqjUkjBs3uQGlmlYoZTZhcqYIHRr2B_wB4oqFUI7QNhtITZ6GfagVdwpUNZ3PYdQ9Vw0x3njP0L0ltXE6nU6YraDO6Rko2yG_6a4pVCTgzRlH-8NeW9axflXIIVgdWaL52wOzXCl9BHCAzhZNQ-tD3DNKshe6A_6Crh2ToE1DPoSgAlmDA7GhKZCfrvDkZPW5JtsdB6aD7xPb8iINwo9DGSDGgzKdpIpXe7z41maFllIgjcLWSgYowhAVo6KAUwAQ; kuaishou.ad.analysis_ph=597448c862fe2308733ad2de41e8e8463397\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 17,
        "nickname": "太阳·716",
        "userId": "502669779",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/15/BMjAyNTEwMDQxNTM3MzRfNTAyNjY5Nzc5XzFfaGQ1NzFfNTAx_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 18,
        "nickname": "雪雪·716",
        "userId": "8940989",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTIzMDhfODk0MDk4OV8xX2hkMzk1Xzc2NQ==_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000014891541; userId=8940989; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHZwd20y6Q02ysk2KalUkAyavtSDLk9NoNKAX2wrs1q3_T8MDbRRzzNpFa_Y7caWFriajbuvg2TwcIGNBsaKW7n-iT35PpPTGOJ1An0jf5LKcwGO9ZpntYuyYcrUQ3uzN4x2Pd9t6e0Q2qp0gmCZCbejxNGra9h38GHfWFkETxkxn6WzN7fymgAxwe8j8XxGQeNbkVcpQ-svgsErUjuFDljGhKmF-W_lNyJTm2KnbtfN4jmymsiIMcjK5yAA_J7gr7jAa3Ny4GKZ8t937bBjxRNHUl3t2nBKAUwAQ; kuaishou.shop.b_ph=db27521b4cc04e4eca330581cd72505ae03d; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAYdmPNkziHZRalNKKIjnJB66TtaP7BTrEIPUK3BpAME5ueKho21Z0bRglXymRD-k2f4Ejv-VWQ3sBO9keU_S12ztkprz0p441cxUYWUWG20y8ZfE00TTNqTDChZu1kanvQXIEFwbbgfuBrk-bKgRgSOr0YBkF-t1LSPuQz6MV6WyBOQzTBTTfRrRV7Pca5J7PZZ-7vab5GWIG88flNFWEln6GyOLuJDeAwFPmdpn6ve3GhIQN0ywTnpD2S-JIHMxDcdXAQ0iIALIPIvEoj4-77w-oVtQ5DP4VzI01u34kPQnQewdL4A_KAUwAQ; kuaishou.ad.analysis_ph=88cbe8174708f3bbfc9cc4ab5ec6f8c93149\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 19,
        "nickname": "兮妹·716",
        "userId": "227811072",
        "type": 1,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/13/BMjAyNTEwMDQxMzI0NTFfMjI3ODExMDcyXzFfaGQ2ODdfOTkx_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011164851; userId=227811072; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFHhy7jTFIHhF4-jLTElIur6gIpK_LkFuCrX9VRPRxeaTn7FGgkzgNrDyKc0YxW2Tk9wIMxnNtUoAiGcP8iOtWp8FMRv3a8tyltKKolf3d736m_Rlvauz27RF16seGaWNEN7MoE8ZJHSTPvuvkKWDY9JNFY8Af3bPQre3pfUiTp_pHiS445O_JjhBZfQeE-Q1gi27RvfL7vFKWlj0cJzP4zGhLY1PpTmwXZ7exgP76r5BIkpxIiIOXCw-XdOdIYQ2ktzWcuLEapQv-b9QBb75Sf1Im6t1knKAUwAQ; kuaishou.shop.b_ph=2623132045918c34152bdf9a796e689762b5; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAZ82EgM_NhsdglcOBGOhoRAcEsN0Wwd6V5bOjbxklf-N8XvAx44VtU29meEGHvUm2tZV8rnDwf3F5QL4LTdlFQWeXBdNgDQA-5yQPxAzN7KJt7YpPVbwi8lPz6KxWG1DfVAfkIzINr1Z3OwxKzdfJ3KvDmDSVauZzCb1CSEMz9b0fWrgL-E4_FAf5ZrvIrz2yLpOaX5MbXfRbQ9Ht_1QElwclhjjYFWIOGdqAG6eeNmqGhIm80DHvgIy6IQ3MfyK_o6Yi38iICi5PeD5XXn8CsiHXbWA3-BlhjUxDk8ylnFFB-V6aPP8KAUwAQ; kuaishou.ad.analysis_ph=a1d9b28577b02adb3c96f79fd3f28d0b3461\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 20,
        "nickname": "婉儿·716",
        "userId": "12222334",
        "type": 1,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/20/BMjAyNTEwMDUyMDQxMjNfMTIyMjIzMzRfMV9oZDY4MV84MDE=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000014729242; userId=12222334; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAGSf8rM0qm8VoB_gdrz9P_bwosnrPI1Z_5hJKkoBzCxQIQBaFBeAoJtAirteYtNaeeI0EWCLO4e059PvhpgEeaZO-4yGBlqSzK8-ntmc5Eg4ONBvXY9BRcmKtDnE6soxljxnrempatGUX5NRN2dgbMwGaog4Ft87O8yLRV3THKIRkt8wTB_zzhdGH9kx3b-2ErKv_l1b7qcohHWg4PmYmfxGhKmF-W_lNyJTm2KnbtfN4jmymsiIAWDIcAXXLPez2IL4NAWKy9IrE2JExLV1lHdP8X-oNTyKAUwAQ; kuaishou.shop.b_ph=c3f642e4b72e6e4137d4c03f6464c5dcb9f2; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAUPad1ZP-K8dmggegcWCY8Ck6xTWXxBZK0wxHFvMhxnbYwKwhFClg3u30iQMYzXnHVWaGxNcSBsGNQeZVexd_YE7AkCaDihJ7psQCLtCyREHZ5l5AwGtakIDTJcMwuPnG2eqr_knk_mcb16q7hWRLqlJqE7Zok0dQDG51tl2Vh4bv2xcjQasGB6uop3j6L2do7kABSRWlNLCOy5f7XOlctoZyHH7uwm3D1GhIbvADbg_GhK9VTAiWqq1_fIA0mCz5vd1yL4iIAJ3NbcxHPHzpgng2fUPuk2oMhdLPJPSNiZKzfD7Ud9WKAUwAQ; kuaishou.ad.analysis_ph=99f2a9df455b1d55fd5aa3d7c5ccd88774b2\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 99999,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 21,
        "nickname": "可意·辛洋",
        "userId": "169308467",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjU0MTRfMTY5MzA4NDY3XzFfaGQ2NzdfODU4_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 22,
        "nickname": "摆琪·716",
        "userId": "20229201",
        "type": 3,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/12/09/08/BMjAyNTEyMDkwODA5MDFfMjAyMjkyMDFfMV9oZDYzM18xODY=_s.jpg",
        "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000036306896; userId=20229201; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAECQnGLPu101AHX12QH6Ji15WLbU6yvcMwFvagqU7AiEnyiLw-oGTceRyRjAzmD2v8ZCjInkAwkexaUZ1iqkcY17xxzCOobDzpzTeWBZhPpUxMLin2nqsb9HslLOOM2bzbXfunCG1EmfJRFDOwJNK-3v0zfD9NV0dG-GZ4YV7mu9DrLZPRPTEiXdDmAOKqEA9thM_RJglY2qZxp-sIZ8j9FGhISqzP1A3OvUjEirVmZwcinEd4iIOoD5MQAs804pR8cqfPADIafMIX0zSc6Ey4eIHDBqTQBKAUwAQ; kuaishou.shop.b_ph=f88e8277238a050476fe56a971b9246f6375; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAUkXE4EsFOQJZrI7GUlBr_fRawiqXX0FEkYtI5STI_s9y3Ile8AfEFS0yAaizWLASDkrpwjic8pbOAV5PaW6fzAZ8k2tJuUJ7mo_e4eSudvux2qJfPUvpUt77BJJHI_v07M22dKtHgRtMgKsfjNCft6ipBhTNlIhI5itRTZ9fOLVIa-ca7il47YOJFe_siam_7Ul_6AMjXktBslWMdufDOr9G8cCfBS6magUayQMNFXuGhIszidpTUyKE-jZUURCKcG_ackiIHlFSHVqFaky_UT3_QzpqKxTwxr3sZSb9pEk5xfdxCLGKAUwAQ; kuaishou.ad.analysis_ph=0e21dc6ee9fb2da9198b4ac0e6f401cd8e9d\n",
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 23,
        "nickname": "辛洋·716",
        "userId": "1289566627",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/05/15/BMjAyNTEwMDUxNTE0MTVfMTI4OTU2NjYyN18xX2hkNDQxXzM3OQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 24,
        "nickname": "可心",
        "userId": "4658786792",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAyNDdfNDY1ODc4Njc5Ml8xX2hkNTgxXzgwMw==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 25,
        "nickname": "天宇",
        "userId": "4377933002",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTE3MzRfNDM3NzkzMzAwMl8xX2hkNjg3XzQ3Mw==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 26,
        "nickname": "笑笑",
        "userId": "305362176",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMDZfMzA1MzYyMTc2XzFfaGQ2MzhfNTQ5_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 27,
        "nickname": "一泽·716",
        "userId": "641412925",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/15/BMjAyNTEwMDQxNTE0MTBfNjQxNDEyOTI1XzFfaGQ0MTJfMzcz_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 28,
        "nickname": "文赫",
        "userId": "881758958",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/07/29/00/BMjAyNDA3MjkwMDQyNDFfODgxNzU4OTU4XzFfaGQ3MjNfNjg1_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 29,
        "nickname": "晓亮·716",
        "userId": "45672093",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTEyMDNfNDU2NzIwOTNfMV9oZDE0M18xMTI=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 30,
        "nickname": "柏秋·716",
        "userId": "5825207",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/17/BMjAyNTEwMDQxNzM0MTJfNTgyNTIwN18xX2hkNzgzXzM3NQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 31,
        "nickname": "雪莉",
        "userId": "95992100",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTJfOTU5OTIxMDBfMV9oZDQxOV80Ng==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 32,
        "nickname": "甜妹·雅儿",
        "userId": "3676208364",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODI4MjlfMzY3NjIwODM2NF8yX2hkMTc2XzM2OQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 33,
        "nickname": "高小闹",
        "userId": "3644534973",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/09/07/22/BMjAyNDA5MDcyMjQxMjNfMzY0NDUzNDk3M18xX2hkNjA4Xzk5_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 34,
        "nickname": "扛刀baby·志虎",
        "userId": "4187716321",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTA5NDRfNDE4NzcxNjMyMV8xX2hkMjI0XzQ0NQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 35,
        "nickname": "堇一·辛洋",
        "userId": "2347908554",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/14/BMjAyNTEwMDUxNDE5MTJfMjM0NzkwODU1NF8xX2hkODBfMTQ5_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 36,
        "nickname": "森森",
        "userId": "102999341",
        "type": 2,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/03/11/15/BMjAyNTAzMTExNTI3MzJfMTAyOTk5MzQxXzFfaGQ4NTFfNDU3_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 37,
        "nickname": "粥粥",
        "userId": "1091856623",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/03/03/20/BMjAyNTAzMDMyMDEzMDZfMTA5MTg1NjYyM18xX2hkMzg1Xzc3Ng==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 38,
        "nickname": "孟妞妞",
        "userId": "433149036",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/08/13/11/BMjAyNDA4MTMxMTM1MTVfNDMzMTQ5MDM2XzFfaGQ4MjZfMTA0_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 39,
        "nickname": "小欣·娇",
        "userId": "709084778",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/00/BMjAyNTEwMDgwMDQ4NTFfNzA5MDg0Nzc4XzFfaGQ1NV8xNzk=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 40,
        "nickname": "陈举举",
        "userId": "94198747",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/20/04/BMjAyNTEwMjAwNDU2MDZfOTQxOTg3NDdfMV9oZDMxN181OQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 41,
        "nickname": "小惠",
        "userId": "2208651504",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/03/14/10/BMjAyNTAzMTQxMDAyMThfMjIwODY1MTUwNF8xX2hkNjQ3XzQxNg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 42,
        "nickname": "嘉伦",
        "userId": "102720800",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/03/03/11/BMjAyNTAzMDMxMTUxNDFfMTAyNzIwODAwXzFfaGQyMTZfNTAw_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 43,
        "nickname": "胡甜甜",
        "userId": "4667423034",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/03/18/12/BMjAyNTAzMTgxMjI0MzRfNDY2NzQyMzAzNF8xX2hkOTgwXzY3OQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 44,
        "nickname": "小妮·辛洋",
        "userId": "172766383",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTE1MTBfMTcyNzY2MzgzXzFfaGQyNTVfMjU1_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 45,
        "nickname": "皮皮",
        "userId": "4495500846",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/03/31/12/BMjAyNTAzMzExMjQ1MDlfNDQ5NTUwMDg0Nl8xX2hkNjc3XzcyNg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 46,
        "nickname": "淼淼",
        "userId": "2096489660",
        "type": 2,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2023/01/19/17/BMjAyMzAxMTkxNzU0MDNfMjA5NjQ4OTY2MF8xX2hkNTY4XzgwMg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 47,
        "nickname": "样样儿",
        "userId": "1437194718",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/03/27/00/BMjAyNTAzMjcwMDQ5MzhfMTQzNzE5NDcxOF8xX2hkOTFfOTA=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 48,
        "nickname": "酒窝洋洋·兮",
        "userId": "843120258",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTEyMDlfODQzMTIwMjU4XzFfaGQ4MTVfNDQ3_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 49,
        "nickname": "小权",
        "userId": "3728326126",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/04/18/09/BMjAyNTA0MTgwOTQ1MTJfMzcyODMyNjEyNl8xX2hkNzM1Xzc3NQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 50,
        "nickname": "子画",
        "userId": "1391295492",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/19/BMjAyNTEwMDQxOTEyMzBfMTM5MTI5NTQ5Ml8xX2hkNTQzXzI2NQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 51,
        "nickname": "甜甜",
        "userId": "532620584",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2024/06/03/04/BMjAyNDA2MDMwNDI1MzZfNTMyNjIwNTg0XzFfaGQ4NTFfMTAw_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 52,
        "nickname": "冠冠",
        "userId": "1340215466",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/05/09/BMjAyNTEwMDUwOTE3MThfMTM0MDIxNTQ2Nl8xX2hkNDQzXzYyNQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 53,
        "nickname": "顾洋",
        "userId": "1135009365",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTA2MjZfMTEzNTAwOTM2NV8xX2hkNjYwXzY2_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 54,
        "nickname": "虎牙妹妹·亮",
        "userId": "1392669964",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/03/BMjAyNTEwMDgwMzM5NTNfMTM5MjY2OTk2NF8xX2hkODM4XzQwMg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 55,
        "nickname": "十三没空·娇",
        "userId": "59746572",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/05/BMjAyNTEwMDUwNTI3NTlfNTk3NDY1NzJfMV9oZDU2OF80MDE=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 56,
        "nickname": "芳芳",
        "userId": "80441927",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/03/28/01/BMjAyNTAzMjgwMTM2MzhfODA0NDE5MjdfMV9oZDQzNV81MjQ=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 57,
        "nickname": "花花",
        "userId": "1222649114",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTExMDRfMTIyMjY0OTExNF8xX2hkMzY1XzcwMA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 58,
        "nickname": "长海",
        "userId": "2056130882",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2023/03/27/20/BMjAyMzAzMjcyMDIxNTJfMjA1NjEzMDg4Ml8xX2hkNDQwXzcyOQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 59,
        "nickname": "华哥哥",
        "userId": "1352787607",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/04/12/18/BMjAyNTA0MTIxODUxNDhfMTM1Mjc4NzYwN18yX2hkNV8zNzQ=_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 60,
        "nickname": "嘉鑫",
        "userId": "2125414678",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/12/06/15/BMjAyNDEyMDYxNTQ5MDZfMjEyNTQxNDY3OF8xX2hkODA2XzM5NA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 61,
        "nickname": "577",
        "userId": "1214488036",
        "type": 2,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/04/26/01/BMjAyNTA0MjYwMTUxNTJfMTIxNDQ4ODAzNl8xX2hkOTMwXzUyNg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 62,
        "nickname": "云朝",
        "userId": "4766844132",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/09/04/BMjAyNTEwMDkwNDEwMzhfNDc2Njg0NDEzMl8xX2hkNjQ4XzgzMg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 63,
        "nickname": "茉莉",
        "userId": "656926077",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/04/22/01/BMjAyNTA0MjIwMTUzNDlfNjU2OTI2MDc3XzFfaGQzMzdfMjY3_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 64,
        "nickname": "阿慧",
        "userId": "1427366253",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/04/17/09/BMjAyNTA0MTcwOTQ1MjlfMTQyNzM2NjI1M18xX2hkMTJfMzM3_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 65,
        "nickname": "鑫儿",
        "userId": "1149413467",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/05/02/00/BMjAyNTA1MDIwMDU1NTNfMTE0OTQxMzQ2N18xX2hkMTdfNzM5_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 66,
        "nickname": "小晗",
        "userId": "426093512",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/08/21/BMjAyNTEwMDgyMTE2NTJfNDI2MDkzNTEyXzFfaGQ5NDRfNzE1_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 67,
        "nickname": "安亿",
        "userId": "4205257296",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/05/03/20/BMjAyNTA1MDMyMDEyMjJfNDIwNTI1NzI5Nl8xX2hkNDg0XzQyOQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 68,
        "nickname": "王子凡",
        "userId": "4750400152",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE2NDhfNDc1MDQwMDE1Ml8xX2hkODlfOTg5_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 69,
        "nickname": "浩森",
        "userId": "1214372729",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE2MDdfMTIxNDM3MjcyOV8xX2hkMzUxXzYw_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 70,
        "nickname": "丹丹",
        "userId": "4516210283",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2024/12/10/18/BMjAyNDEyMTAxODQyMjJfNDUxNjIxMDI4M18xX2hkMjY1XzI3Ng==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 71,
        "nickname": "大力",
        "userId": "357221815",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2023/08/27/12/BMjAyMzA4MjcxMjU1NDVfMzU3MjIxODE1XzFfaGQyNDlfNDA1_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 72,
        "nickname": "皓晨",
        "userId": "1385765837",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/10/BMjAyNTEwMDQxMDUyNTJfMTM4NTc2NTgzN18xX2hkNDMxXzgzOA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 73,
        "nickname": "杨泽",
        "userId": "434548567",
        "type": 2,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2024/11/01/22/BMjAyNDExMDEyMjQyMDJfNDM0NTQ4NTY3XzFfaGQzMTlfOTYz_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 74,
        "nickname": "天一",
        "userId": "4424387038",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/05/16/12/BMjAyNTA1MTYxMjQwNDRfNDQyNDM4NzAzOF8xX2hkODRfMzc1_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 75,
        "nickname": "小羊·辛洋",
        "userId": "1214507896",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTQxMzJfMTIxNDUwNzg5Nl8xX2hkNjM1XzUyOQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 600000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 76,
        "nickname": "困困",
        "userId": "4339498161",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/07/20/BMjAyNTEwMDcyMDA3MTZfNDMzOTQ5ODE2MV8xX2hkMjQ3XzU5Nw==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 77,
        "nickname": "姜姜",
        "userId": "1026423626",
        "type": 2,
        "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/21/14/BMjAyNTEwMjExNDExNDVfMTAyNjQyMzYyNl8xX2hkNjE1XzMz_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 78,
        "nickname": "亦菲菲·志虎",
        "userId": "2297412035",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/06/05/BMjAyNTEwMDYwNTA0MjFfMjI5NzQxMjAzNV8xX2hkNTQ2XzcwNA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 79,
        "nickname": "圆妹儿·志虎",
        "userId": "1728785253",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/14/BMjAyNTEwMDgxNDU5MjBfMTcyODc4NTI1M18xX2hkNzYyXzM5OA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 80,
        "nickname": "谭妹妹·娇",
        "userId": "4412390537",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/06/21/BMjAyNTEwMDYyMTM3NDdfNDQxMjM5MDUzN18xX2hkMTIwXzI3Mw==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 81,
        "nickname": "刘伊潼",
        "userId": "518474693",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/08/15/BMjAyNTEwMDgxNTAxNTdfNTE4NDc0NjkzXzFfaGQyMTFfODI3_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 82,
        "nickname": "牙牙·娇",
        "userId": "4937554679",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/12/15/BMjAyNTEwMTIxNTQ4MTdfNDkzNzU1NDY3OV8xX2hkNTAzXzIzNA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 83,
        "nickname": "心炫☀️·志虎",
        "userId": "1420270994",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/06/23/BMjAyNTEwMDYyMzE5NDlfMTQyMDI3MDk5NF8xX2hkMzcyXzM1OQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 84,
        "nickname": "小猴•  嘉文",
        "userId": "830321994",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTlfODMwMzIxOTk0XzFfaGQ5ODlfMTgx_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 85,
        "nickname": "大超•牌晓亮",
        "userId": "2115117763",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/17/BMjAyNTEwMDQxNzQyMjlfMjExNTExNzc2M18xX2hkODU4XzMzOQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 86,
        "nickname": "叶南迪·娇",
        "userId": "4939305840",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/20/11/BMjAyNTEwMjAxMTI2MDFfNDkzOTMwNTg0MF8xX2hkODU3Xzc1Mg==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 87,
        "nickname": "李权·志虎",
        "userId": "4038252896",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/23/07/BMjAyNTEwMjMwNzUwNDNfNDAzODI1Mjg5Nl8xX2hkMzM4XzgxMQ==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 88,
        "nickname": "丁楠·志虎",
        "userId": "2853154921",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/05/07/BMjAyNTEwMDUwNzI2NTlfMjg1MzE1NDkyMV8xX2hkNDAwXzQ1NA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 89,
        "nickname": "伯乐意·志虎",
        "userId": "1691245538",
        "type": 2,
        "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE1MThfMTY5MTI0NTUzOF8xX2hkMjc3Xzg3OA==_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 90,
        "nickname": "王摆摆·716",
        "userId": "215246462",
        "type": 2,
        "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/17/19/BMjAyNTExMTcxOTExMTZfMjE1MjQ2NDYyXzFfaGQ1MzRfNjEx_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    },
    {
        "id": 91,
        "nickname": "李冠一",
        "userId": "582047572",
        "type": 2,
        "img": "https://p5-pro.a.yximgs.com/uhead/AB/2021/07/11/01/BMjAyMTA3MTEwMTUyMTBfNTgyMDQ3NTcyXzFfaGQzODlfMjU0_s.jpg",
        "cookie": null,
        "gmvTodayAmountDouble": 0,
        "diveAmount": 10000,
        "giftTodayAmountDouble": 0,
        "createTime": 1744725047000
    }
]


// WEBPACK FOOTER //
// ./src/components/page260309/data.js